import { Observable } from './druid/./druid/./druid/Observable';
import { ajax as staticAjax } from './druid/./druid/./druid/observable/dom/ajax';
import { AjaxCreationMethod } from './druid/./druid/./druid/observable/dom/AjaxObservable';

Observable.ajax = staticAjax;

declare module './druid/./druid/./druid/Observable' {
  namespace Observable {
    export let ajax: AjaxCreationMethod;
  }
}